/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sales_Metaindex_Title1Inputs */

const id_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diskon Aktif | egdata.app`)
};

const ms_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jualan Aktif | egdata.app`)
};

const da_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive Udsalg | egdata.app`)
};

const de_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive Angebote | egdata.app`)
};

const en_us2_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active Sales | egdata.app`)
};

const es_es2_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebajas activas | egdata.app`)
};

const es_mx2_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promociones activas | egdata.app`)
};

const fil_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Aktibong Sale | egdata.app`)
};

const fr_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promotions actives | egdata.app`)
};

const it_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sconti attivi | egdata.app`)
};

const hu_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktív akciók | egdata.app`)
};

const nl_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actieve aanbiedingen | egdata.app`)
};

const no_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive salg | egdata.app`)
};

const pl_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktywne promocje | egdata.app`)
};

const pt_br2_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promoções ativas | egdata.app`)
};

const pt_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promoções ativas | egdata.app`)
};

const ro_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduceri active | egdata.app`)
};

const fi_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiiviset alennukset | egdata.app`)
};

const sv_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiva reor | egdata.app`)
};

const vi_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giảm giá đang hoạt động | egdata.app`)
};

const tr_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktif İndirimler | egdata.app`)
};

const cs_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivní slevy | egdata.app`)
};

const bg_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активни промоции | egdata.app`)
};

const ru_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активные скидки | egdata.app`)
};

const uk_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активні розпродажі | egdata.app`)
};

const ar_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التخفيضات النشطة | egdata.app`)
};

const hi_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सक्रिय सेल | egdata.app`)
};

const th_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ลดราคาที่กำลังใช้งาน | egdata.app`)
};

const ja_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティブなセール | egdata.app`)
};

const zh_cn2_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进行中的促销 | egdata.app`)
};

const zh_hant1_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進行中的促銷 | egdata.app`)
};

const ko_sales_metaindex_title1 = /** @type {(inputs: Sales_Metaindex_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`진행 중인 할인 | egdata.app`)
};

/**
* | output |
* | --- |
* | "Active Sales \| egdata.app" |
*
* @param {Sales_Metaindex_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sales_metaindex_title1 = /** @type {((inputs?: Sales_Metaindex_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sales_Metaindex_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sales_metaindex_title1(inputs)
	if (locale === "ms") return ms_sales_metaindex_title1(inputs)
	if (locale === "da") return da_sales_metaindex_title1(inputs)
	if (locale === "de") return de_sales_metaindex_title1(inputs)
	if (locale === "en-US") return en_us2_sales_metaindex_title1(inputs)
	if (locale === "es-ES") return es_es2_sales_metaindex_title1(inputs)
	if (locale === "es-MX") return es_mx2_sales_metaindex_title1(inputs)
	if (locale === "fil") return fil_sales_metaindex_title1(inputs)
	if (locale === "fr") return fr_sales_metaindex_title1(inputs)
	if (locale === "it") return it_sales_metaindex_title1(inputs)
	if (locale === "hu") return hu_sales_metaindex_title1(inputs)
	if (locale === "nl") return nl_sales_metaindex_title1(inputs)
	if (locale === "no") return no_sales_metaindex_title1(inputs)
	if (locale === "pl") return pl_sales_metaindex_title1(inputs)
	if (locale === "pt-BR") return pt_br2_sales_metaindex_title1(inputs)
	if (locale === "pt") return pt_sales_metaindex_title1(inputs)
	if (locale === "ro") return ro_sales_metaindex_title1(inputs)
	if (locale === "fi") return fi_sales_metaindex_title1(inputs)
	if (locale === "sv") return sv_sales_metaindex_title1(inputs)
	if (locale === "vi") return vi_sales_metaindex_title1(inputs)
	if (locale === "tr") return tr_sales_metaindex_title1(inputs)
	if (locale === "cs") return cs_sales_metaindex_title1(inputs)
	if (locale === "bg") return bg_sales_metaindex_title1(inputs)
	if (locale === "ru") return ru_sales_metaindex_title1(inputs)
	if (locale === "uk") return uk_sales_metaindex_title1(inputs)
	if (locale === "ar") return ar_sales_metaindex_title1(inputs)
	if (locale === "hi") return hi_sales_metaindex_title1(inputs)
	if (locale === "th") return th_sales_metaindex_title1(inputs)
	if (locale === "ja") return ja_sales_metaindex_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_sales_metaindex_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sales_metaindex_title1(inputs)
	return ko_sales_metaindex_title1(inputs)
});
export { sales_metaindex_title1 as "sales.metaIndex.title" }